import { Injectable } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { finalize, Observable, of, shareReplay, switchMap, throwError } from 'rxjs';
import { StepUp2faModalComponent } from '@app/shared/components/step-up-2fa-modal/step-up-2fa-modal.component';

/**
 * Điều phối Step-up 2FA cho toàn app: mở modal nhập mã, gom các request đồng thời vào 1 lần step-up.
 * Được `AppInterceptor` gọi khi gặp response `MFA_STEP_UP_REQUIRED`.
 */
@Injectable({ providedIn: 'root' })
export class StepUpService {
  private inProgress$: Observable<any> | null = null;

  constructor(private modal: NzModalService) {}

  /** Mở modal (nếu chưa mở); hoàn tất khi step-up thành công, lỗi khi user hủy. */
  ensureStepUp(): Observable<any> {
    if (this.inProgress$) {
      return this.inProgress$;
    }
    const modalRef = this.modal.create({
      nzTitle: 'Xác thực 2 lớp',
      nzContent: StepUp2faModalComponent,
      nzFooter: null,
      nzMaskClosable: false,
      nzWidth: 380
    });
    this.inProgress$ = modalRef.afterClose.pipe(
      switchMap((result: any) => (result === true ? of(true) : throwError(() => 'STEP_UP_CANCELLED'))),
      finalize(() => { this.inProgress$ = null; }),
      shareReplay(1)
    );
    return this.inProgress$;
  }
}
